import DispatchingController from './dispatching.controller';

export default {
    template: require('./dispatching.html'),
    controller: DispatchingController
};
